module.exports = __webpack_public_path__ + "img/35.c9f9a45c.jpg";